import { ErrorMessage, FieldProps } from 'formik';
import * as React from 'react';
// @ts-ignore
import Creatable from 'react-select/creatable';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '../';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { Label, Span } from '../../../typography';

type Option = { label: string; value: boolean | string | number; isFixed?: boolean };

type CustomProps = StyledSystemProps & {
  options: Array<Option>;
  name: string;
  label?: string;
  isClearable?: boolean;
  color?: string;
  placeholder?: string;
  isMulti?: boolean;
  onCreate?: Function;
  onChangeHandler?: Function;
  checkNew?: boolean;
};

const StyledSelect = styled(Creatable)`
  & .react-select__control {
    min-height: 40px;
  }
  & .react-select__menu .react-select__menu-list .react-select__option--is-selected {
    background-color: ${themeGet('colors.putty', '#EEE')};
  }
  & .react-select__control--is-focused {
    border: solid 2px ${themeGet('colors.putty', '#EEE')};
    box-shadow: none;
  }
  & .react-select__control:hover {
    border: solid 2px ${themeGet('colors.putty', '#EEE')};
    box-shadow: none;
  }
`;

const StyledFormSelect: React.FC<Omit<FieldProps, 'meta'> & CustomProps> = props => {
  const { onCreate, onChangeHandler, ...rest } = props;
  const [customOption, setCustomOption] = React.useState<Option[]>([]);

  return (
    <Box {...rest}>
      <Label htmlFor={props.field.name}>{props.label}</Label>
      <StyledSelect
        isClearable={props.isClearable}
        classNamePrefix="react-select"
        name={props.field.name}
        isMulti={props.isMulti}
        options={[...props.options, ...customOption]}
        onBlur={props.field.onBlur}
        onCreateOption={
          props.checkNew
            ? undefined
            : (inputValue: string) => {
                const option = [
                  {
                    label: inputValue,
                    value: inputValue,
                  },
                ];
                setCustomOption(option);
                if (props.onCreate) props.onCreate(option);
              }
        }
        getNewOptionDatas={
          !props.checkNew
            ? undefined
            : (inputValue: string) => {
                const option = [
                  {
                    label: inputValue,
                    value: inputValue,
                  },
                ];
                setCustomOption(option);
                if (props.onCreate) props.onCreate(option);
                return option;
              }
        }
        onChange={(option: any) => {
          props.form.setFieldValue(props.field.name, option);
          if (onChangeHandler) onChangeHandler(option);
        }}
        value={props.field.value}
      />
      <ErrorMessage name={props.field.name}>
        {msg => {
          return (
            <Span mt={2} color="error" textAlign="right">
              {msg}
            </Span>
          );
        }}
      </ErrorMessage>
    </Box>
  );
};

export default StyledFormSelect;

StyledFormSelect.defaultProps = {
  options: [],
  mb: 3,
  flex: 1,
  minWidth: '150px',
  width: '100%',
};
